"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const check_svg_1 = __importDefault(require("images/utility-icons/check.svg"));
const edit_2_svg_1 = __importDefault(require("images/utility-icons/edit-2.svg"));
const inline_colors_1 = require("inline-colors");
function EditableInput({ initialValue, prefix, suffix, onSave, inputType, inputValidator, inputFormatter, }) {
    const [editMode, setEditMode] = (0, react_1.useState)(false);
    const inputBox = (0, react_1.useRef)(null);
    const [value, setValue] = (0, react_1.useState)(inputFormatter(initialValue));
    (0, react_1.useEffect)(() => {
        inputBox?.current?.focus();
    }, [editMode]);
    let prefixDisplay = '';
    let suffixDisplay = '';
    if (prefix) {
        prefixDisplay = prefix;
    }
    if (suffix) {
        suffixDisplay = suffix;
    }
    const edit = () => {
        setEditMode(true);
    };
    const handleEnter = (e) => {
        if (e.key === 'Enter') {
            save();
        }
    };
    const save = () => {
        if (inputValidator) {
            inputValidator(value);
        }
        let formattedValue = value;
        if (inputFormatter) {
            formattedValue = inputFormatter(formattedValue);
            setValue(formattedValue);
        }
        setEditMode(false);
        if (onSave) {
            onSave(formattedValue);
        }
    };
    const updateValue = (targetValue) => {
        const targetValueToUpdate = targetValue;
        if (inputValidator && inputValidator(targetValueToUpdate)) {
            setValue(targetValueToUpdate);
            return targetValueToUpdate;
        }
        return targetValueToUpdate;
    };
    return ((0, jsx_runtime_1.jsxs)("td", { children: [!editMode && ((0, jsx_runtime_1.jsxs)("div", { style: { alignItems: 'center', display: 'flex' }, children: [(0, jsx_runtime_1.jsxs)("span", { style: {
                            paddingLeft: '10%',
                            width: 'auto',
                            display: 'inline-block',
                            font: 'inherit',
                        }, children: [prefixDisplay, value, suffixDisplay] }), (0, jsx_runtime_1.jsx)("span", { onClick: edit, style: { paddingLeft: '3%', cursor: 'pointer' }, role: "button", tabIndex: 0, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                edit();
                            }
                        }, children: (0, jsx_runtime_1.jsx)("img", { src: edit_2_svg_1.default, alt: "", style: { height: '20px', width: '20px' } }) })] })), !!editMode && ((0, jsx_runtime_1.jsxs)("div", { style: { alignItems: 'center', display: 'flex' }, children: [prefixDisplay, (0, jsx_runtime_1.jsx)("input", { style: {
                            width: '70px',
                            font: 'inherit',
                            display: 'inline-block',
                            border: 0,
                            borderBottom: `1px solid ${inline_colors_1.INLINE_COLORS.darkgreyLight}`,
                            backgroundColor: inline_colors_1.INLINE_COLORS.lightblueBase,
                        }, name: "jake", type: inputType, value: value, ref: inputBox, onChange: (e) => updateValue(e.target.value), onBlur: save, onKeyDown: handleEnter }), suffix, (0, jsx_runtime_1.jsx)("span", { onClick: save, style: {
                            paddingLeft: '3%',
                            cursor: 'pointer',
                            display: 'inline-block',
                        }, role: "button", tabIndex: 0, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                save();
                            }
                        }, children: (0, jsx_runtime_1.jsx)("img", { src: check_svg_1.default, alt: "", style: { height: '25px', width: '25px' } }) })] }))] }));
}
exports.default = (0, react_1.memo)(EditableInput);
